import { TCreateOrganizationForm, TOrganizationContractForm } from './schema';
import { ELanguage, EOrganizationProvisioningType } from '@/types';

export const EMPTY_CONTRACT: TOrganizationContractForm = {
  seats: null,
  stationLicenses: null,
  consultsPerMonth: null,
  contractStartDate: null,
  contractEndDate: null,
};

export const defaultValues: TCreateOrganizationForm = {
  name: '',
  language: ELanguage.EN,
  country: null,
  state: null,
  address1: null,
  address2: null,
  city: null,
  zip: null,
  pocSettings: {
    name: '',
    title: '',
    email: '',
    phone: {
      country: '',
      number: '',
    },
    country: null,
    state: null,
    address1: null,
    address2: null,
    zip: null,
  },
  configuration: {
    tfa: false,
    symptomTriage: false,
    triageProvider: undefined,
    medicalStationCalls: false,
    canarySpeech: false,
    medwand: false,
  },
  provisioning: {
    type: EOrganizationProvisioningType.SEATS,
    scope: '',
    contracts: [EMPTY_CONTRACT],
  },
};
